// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3afac8d0","455":"1bba3bcd","977":"03902799"}[chunkId] + ".chunk.js";
};